/**
 * Loading place filter for the individual benchmarking graphs.
 *
 * Every delivery carries the loading place it came from (DELPLCE), so the
 * filter runs on the data already loaded. The week average is the BPG-wide
 * average of that week and does not depend on the supplier's loading places,
 * so it is never filtered.
 */

/** The loading places the weeks have deliveries from, each once, sorted. */
export const getLoadingPlaces = weeks =>
  [
    ...new Set(
      weeks.flatMap(week => week.deliveries.map(delivery => delivery.DELPLCE))
    ),
  ].sort();

/**
 * Keeps only the deliveries from the selected loading places. A week left
 * without deliveries is dropped, the same way the webservice leaves out weeks
 * the supplier did not deliver in.
 */
export const filterWeeksByLoadingPlace = (weeks, selected) => {
  const selectedSet = new Set(selected);
  return weeks
    .map(week => ({
      ...week,
      deliveries: week.deliveries.filter(delivery =>
        selectedSet.has(delivery.DELPLCE)
      ),
    }))
    .filter(week => week.deliveries.length > 0);
};
